import httpClient from "./httpClient";
import { ANIMAL_SPLIT_CORE } from "../constants";

/**
 * Upload an image to the server
 * @param {File} file - The image file to upload
 * @returns {Promise<Object>} - Response with image ID, key, and proxy URL
 */
export const uploadImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);

    const { data } = await httpClient.post(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/images`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get the full URL for an image by ID
 * @param {string} imageId - The image ID
 * @returns {string} - Full URL to the image
 */
export const getImageUrl = (imageId) => {
  return `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/images/${imageId}`;
};

/**
 * Get an image by ID (returns the actual image data)
 * @param {string} imageId - The image ID
 * @returns {Promise<Blob>} - The image blob
 */
export const getImage = async (imageId) => {
  try {
    const { data } = await httpClient.get(
      `${ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL}/api/images/${imageId}`,
      {
        responseType: 'blob',
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};
